module.exports = __webpack_public_path__ + "assets/addReviewCommentHover.8ae9f969.svg";